module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Tools/Roller-bbc0f8f862a14c64f958e2c377044b73.svg";